import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
/**
 * Holds parentId/fieldId links for each node, allowing to do custom checks against structure
 */
export var ParentTree = /*#__PURE__*/function () {
  function ParentTree() {
    _classCallCheck(this, ParentTree);
    _defineProperty(this, "value", {});
  }
  _createClass(ParentTree, [{
    key: "setNodeParent",
    value: function setNodeParent(nodeId, parentTarget) {
      this.value[nodeId] = parentTarget;
    }

    /** Test if node is ancestor of target */
  }, {
    key: "isAncestor",
    value: function isAncestor(nodeId, targetId) {
      if (nodeId === targetId) return true;
      if (!nodeId || !this.value[nodeId]) return false;
      return this.isAncestor(this.value[nodeId].parentId, targetId);
    }
  }]);
  return ParentTree;
}();